const customer = ({ order }) => {
  return (
    <>
      <div className="map-marker-hint--title">
        <strong>{order.customer_name}</strong>
      </div>
    </>
  );
};
export default customer;
